import {
  FETCH_KITCHEN_DISHES,
  FETCH_KITCHEN_DISHES_SUCCESS,
  FETCH_KITCHEN_DISHES_FAILURE,
  SAVE_KITCHEN_DISH,
  DELETE_KITCHEN_DISH,
  FETCH_KITCHEN_MENUS,
  FETCH_KITCHEN_MENUS_SUCCESS,
  FETCH_KITCHEN_MENUS_FAILURE,
  SAVE_KITCHEN_MENU,
  PUBLISH_KITCHEN_MENU,
  UNPUBLISH_KITCHEN_MENU,
  FETCH_KITCHEN_DISH,
  FETCH_DISH_PHOTO_LIBRARY,
  UPLOAD_DISH_PHOTO,
  ATTACH_DISH_PHOTO,
  UPDATE_DISH_PHOTO,
  DELETE_DISH_PHOTO,
  POLISH_DISH_PHOTO,
  TIDY_DISH_DESCRIPTION,
  FETCH_MEAL_SITTINGS,
  FETCH_MEAL_SITTINGS_SUCCESS,
  FETCH_MEAL_SITTINGS_FAILURE,
  SAVE_MEAL_SITTINGS,
} from "./constants";

export const fetchKitchenDishes = (payload) => ({
  type: FETCH_KITCHEN_DISHES,
  payload,
});
export const fetchKitchenDishesSuccess = (payload) => ({
  type: FETCH_KITCHEN_DISHES_SUCCESS,
  payload,
});
export const fetchKitchenDishesFailure = () => ({
  type: FETCH_KITCHEN_DISHES_FAILURE,
});

export const saveKitchenDish = (payload, onDone) => ({
  type: SAVE_KITCHEN_DISH,
  payload,
  onDone,
});
export const deleteKitchenDish = (payload, onDone) => ({
  type: DELETE_KITCHEN_DISH,
  payload,
  onDone,
});

export const fetchKitchenMenus = (payload) => ({
  type: FETCH_KITCHEN_MENUS,
  payload,
});
export const fetchKitchenMenusSuccess = (payload) => ({
  type: FETCH_KITCHEN_MENUS_SUCCESS,
  payload,
});
export const fetchKitchenMenusFailure = () => ({
  type: FETCH_KITCHEN_MENUS_FAILURE,
});

export const saveKitchenMenu = (payload, onDone) => ({
  type: SAVE_KITCHEN_MENU,
  payload,
  onDone,
});
export const publishKitchenMenu = (payload, onDone) => ({
  type: PUBLISH_KITCHEN_MENU,
  payload,
  onDone,
});
export const unpublishKitchenMenu = (payload, onDone) => ({
  type: UNPUBLISH_KITCHEN_MENU,
  payload,
  onDone,
});

// Dish photos + ✦ Tidy (wave 2). `(payload, onSuccess, onError)`; onError gets
// `{ status, notFound, forbidden, message }` so the editor can tell an older API
// (404 — no photo endpoints yet) from a real failure.
const withCallbacks = (type) => (payload, onSuccess, onError) => ({
  type,
  payload,
  onSuccess,
  onError,
});

export const fetchKitchenDish = withCallbacks(FETCH_KITCHEN_DISH);
export const fetchDishPhotoLibrary = withCallbacks(FETCH_DISH_PHOTO_LIBRARY);
export const uploadDishPhoto = withCallbacks(UPLOAD_DISH_PHOTO);
export const attachDishPhoto = withCallbacks(ATTACH_DISH_PHOTO);
export const updateDishPhoto = withCallbacks(UPDATE_DISH_PHOTO);
export const deleteDishPhoto = withCallbacks(DELETE_DISH_PHOTO);
export const polishDishPhoto = withCallbacks(POLISH_DISH_PHOTO);
export const tidyDishDescription = withCallbacks(TIDY_DISH_DESCRIPTION);

// Meal times per home (wave 3). `fetchMealSittings({ locationId, force })` and
// `saveMealSittings({ locationId, sittings })` take `(payload, onSuccess, onError)`;
// onError gets `{ status, notFound, forbidden, needsUpdate, fieldErrors, message }`.
export const fetchMealSittings = withCallbacks(FETCH_MEAL_SITTINGS);
export const saveMealSittings = withCallbacks(SAVE_MEAL_SITTINGS);
export const fetchMealSittingsSuccess = (payload) => ({
  type: FETCH_MEAL_SITTINGS_SUCCESS,
  payload,
});
export const fetchMealSittingsFailure = (payload) => ({
  type: FETCH_MEAL_SITTINGS_FAILURE,
  payload,
});
